import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/getstarted',
    name: 'GetStarted',
    component: () =>
      import(/* webpackChunkName: "getstarted" */ '../views/GetStarted.vue'),
  },
  {
    path: '/zone',
    name: 'ZonePage',
    component: () =>
      import(/* webpackChunkName: "zone" */ '../views/ZonePage.vue'),
  },
  {
    path: '/create',
    name: 'CreateZone',
    component: () =>
      import(/* webpackChunkName: "zone" */ '../views/CreateZone.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
